import React from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import Col from "../../common/Col";
import Row from "../../common/Row";
import Fieldset from "../../common/Fieldset";
import MapView from "../../common/map/MapView";
import Section from "../../common/Section";
import ANBGebied from "../../../images/map/ANBGebied.png";
import { Button } from "semantic-ui-react";

const ConflictBeoordelingForm = (props) => {
    const {
        disabled,
        color,
        osmBaseLayerUrl,
        model,
        customBounds,
        beoordeelConflict,
        closePage
    } = props;


    const bestaandeLus = model.bestaandeLus;
    const gewijzigdeLus = model.gewijzigdeLus;
    const typeEnNaam = (type, naam) => type ? `${type} - ${naam}` : naam;
    const geoJsonLayers = [
        { id: 'bestaandeLus', data: bestaandeLus.geoJson, style: { color: "cyan" }, showDirection: true },
        { id: 'gewijzigdeLus', data: gewijzigdeLus.geoJson, style: { color: "red" }, showDirection: true }
    ];
    return (
        <Form name="ConflictBeoordeling"
            headerVisible={false}
            isNotRequired
            color={color}>
            <Fieldset>
                <Row >
                    <Col size={6} className="center-text">
                        <p><b>{typeEnNaam(gewijzigdeLus.tochtType, gewijzigdeLus.tochtNaam)}</b></p><br />
                        <p>{typeEnNaam(gewijzigdeLus.lusType, gewijzigdeLus.naam)}</p>
                        <p>{gewijzigdeLus.organisatorNaam}</p><br />

                    </Col>
                    <Col size={6} className="center-text">
                        <p><b>{typeEnNaam(bestaandeLus.tochtType, bestaandeLus.tochtNaam)}</b></p><br />
                        <p>{typeEnNaam(bestaandeLus.lusType, bestaandeLus.naam)}</p>
                        <p>{bestaandeLus.organisatorNaam}</p><br />
                    </Col>
                </Row>
                <Row>
                    <MapView
                        baseLayerUrl={osmBaseLayerUrl}
                        mapName="route"
                        geoJsonLayers={geoJsonLayers}
                        zoom={12}
                        bounds={customBounds}
                    />
                </Row>
                <br/>
                <Row>
                    <Col size={4} >
                        <Button  className={"c-button c-button--cancel"} type="button" onClick={() => closePage()}>Sluiten</Button>
                    </Col>
                     <Col size={4} className="center-text" >
                        <Button className={"c-button"} type="button" onClick={() => beoordeelConflict(false)}>Geen conflict</Button>
                    </Col>
                     <Col size={4} className="right-text" >
                        <Button className={"c-button"} type="button" onClick={() => beoordeelConflict(true)}>Conflict</Button>
                    </Col>
                </Row>
            </Fieldset>
        </Form>);
};


ConflictBeoordelingForm.propTypes = {
    disabled: PropTypes.bool,
    color: PropTypes.string,
    osmBaseLayerUrl: PropTypes.string,
    model: PropTypes.object,
    customBounds: PropTypes.object,
    beoordeelConflict: PropTypes.func.isRequired,
    closePage: PropTypes.func.isRequired
};

export default ConflictBeoordelingForm;